import {
  Component,
  Input,
  OnInit,
  Output,
  EventEmitter,
  ChangeDetectionStrategy
} from '@angular/core';
import {
  AircraftProfileComponentAudit,
  ComponentAudit
} from '../../+models/aircraft-profile-audit.model';

@Component({
  selector: 'sd-portal-component-audit-list',
  templateUrl: './component-audit-list.component.html',
  styleUrls: ['./component-audit-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ComponentAuditListComponent implements OnInit {
  @Input() aircraftProfileComponentId: number;
  @Input() componentId: number;
  @Input() loading: boolean;
  @Input() aircraftProfileComponentAudits: AircraftProfileComponentAudit[];
  @Input() componentAudits: ComponentAudit[];

  @Output() loadComponent = new EventEmitter<{
    aircraftProfileComponentId: number;
    componentId: number;
  }>();

  @Output() nextPage = new EventEmitter<{
    aircraftProfileComponentId: number;
    componentId: number;
  }>();

  constructor() {}

  ngOnInit() {}

  loadData() {
    this.loadComponent.emit({
      aircraftProfileComponentId: this.aircraftProfileComponentId,
      componentId: this.componentId
    });
  }

  onNextPage() {
    this.nextPage.emit({
      aircraftProfileComponentId: this.aircraftProfileComponentId,
      componentId: this.componentId
    });
  }
}
